<template>
  <v-container>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <h1>Your Info</h1>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Your role:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-select
          :value="role"
          @change="setRole"
          :items="roles"
          single-line
          outline
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Your phone number:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          :value="phone"
          @change="setPhone"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import roles from '../../../../static/account-roles'
export default {
  name: 'AdminUserInfo',
  data () {
    return {
      roles: []
    }
  },
  props: {
    role: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    }
  },
  created () {
    this.roles = roles
  },
  methods: {
    setRole (value) {
      this.$emit('setField', 'role', value)
    },
    setPhone (value) {
      this.$emit('setField', 'phone', value)
    }
  }
}
</script>
